"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUserUUIDFromUsername = void 0;
var uuid_1 = require("uuid");
var CONSUMER_UUID_GENERATION_NAMESPACE = 'eb2f4eca-1950-4736-ae3e-2057266761e8';
function generateUserUUIDFromUsername(userName) {
    return uuid_1.v5(userName, CONSUMER_UUID_GENERATION_NAMESPACE);
}
exports.generateUserUUIDFromUsername = generateUserUUIDFromUsername;
//# sourceMappingURL=authentication.provider.js.map